import { render, staticRenderFns } from "./IndexCfu.vue?vue&type=template&id=2bead6c9&scoped=true&"
import script from "./IndexCfu.vue?vue&type=script&lang=js&"
export * from "./IndexCfu.vue?vue&type=script&lang=js&"
import style0 from "./IndexCfu.vue?vue&type=style&index=0&id=2bead6c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bead6c9",
  null
  
)

export default component.exports